import { Buttons } from "./buttons"
import { Checkboxes } from "./checkboxes"
import { ContactForm } from "./contact-form"
import { Counter } from "./counter"
import { Download } from "./download"
import { EmergencyLinks } from "./emergency-links"
import { Image } from "./image"
import { CitySelectOptions } from "./select-options"
import { Summary } from "./summary"
import { Text } from "./text"
import { Textarea } from "./text-area"

export const ContentType = (props) => {
  let el
  switch (props.type) {
    case "buttons":
      el = <Buttons {...props} />
      break
    case "checkboxes":
      el = <Checkboxes {...props} />
      break
    case "counter":
      el = <Counter {...props} />
      break
    case "summary":
      el = <Summary {...props} />
      break
    case "textarea":
      el = <Textarea {...props} />
      break
    case "contactform":
      el = <ContactForm {...props} />
      break
    case "download":
      el = <Download {...props} />
      break
    case "emergency_links":
      el = <EmergencyLinks {...props} />
      break
    case "city_select":
      el = <CitySelectOptions {...props} />
      break
    case "image":
      el = <Image {...props} />
      break
    default:
      el = <Text {...props} />
      break
  }
  return el
}
